import { __decorate, __metadata } from 'tslib';
import { Service } from '../../decorators/class/service.js';
import { BuiltinUiState } from '../store/builtin-state.js';
import { StateManager } from '../store/state-manager.js';

/**
 * feature级别功能配置服务
 * @public
 */
let ConfigFeatureService = class ConfigFeatureService {
    constructor(store) {
        this.store = store;
        // feature级别开关
        this.disabledFeature = new Set();
        this.store.register(BuiltinUiState.FeatureStatus, this.disabledFeature);
    }
    /**
     * 设置Feature开关，被关闭的不会被点击
     */
    disableFeature(name) {
        this.disabledFeature.add(name);
        this.store.update(BuiltinUiState.FeatureStatus, this.disabledFeature);
    }
    /**
     * 设置Feature开关，被关闭的不会被点击
     */
    enableFeature(name) {
        this.disabledFeature.delete(name);
        this.store.update(BuiltinUiState.FeatureStatus, this.disabledFeature);
    }
};
ConfigFeatureService = __decorate([
    Service({ overridable: true }),
    __metadata("design:paramtypes", [StateManager])
], ConfigFeatureService);

export { ConfigFeatureService };
//# sourceMappingURL=config-feature-service.js.map
